import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: null,
};

const couponFilterSlice = createSlice({
  name: "couponFilter",
  initialState,
  reducers: {
    setCouponSearch: (state, action) => {
      state.search = action.payload ?? null;
    },
    clearCouponSearch: () => initialState,
  },
});

export const {
  setCouponSearch,
  clearCouponSearch,
} = couponFilterSlice.actions;

export const selectCouponSearch = (state) => state.couponFilter.search;

export default couponFilterSlice.reducer;
